export enum BooleanType {
  TRUE = "T",
  FALSE = "F",
}
